module.exports = __webpack_public_path__ + "img/Will Villanueva.3701eba6.png";